import { getCurrencyListApi, getGlobalSetApi, memberLoginApi, memberGuestLoginApi, memberLogoutApi, memberRegisterApi, contactUsSavaApi } from '@/apis/common/index';
import { setSelectCurrency, getSelectCurrency, getSelectLanguage, setAccountFun } from '@/store/locale';
import { setUserIdFun, setToken, setUsername } from '@/store/locale';
import type { LanguageObj, RegisterForm, ContactUsLo } from '@/logic/header/model/index';
import { NewLanguageInfo } from '@/logic/header/model/index';

// 币种接口调用
export const getCurrencyListData = async (cid: string) => {
	const res = await getCurrencyListApi({ cid: cid });
	// 如果没有默认币种就给store传一个默认币种
	if (!getSelectCurrency()) {
		setSelectCurrency(res.selectCurrency);
	} else {
		// 如果有了设置的币种那么vo就显示默认币种
		res.selectCurrency = getSelectCurrency();
	}
	return res;
};
// 语言接口调用
export const getLanguageListData = async (lang: string, currency: string) => {
	const res = await getGlobalSetApi({ lang, currency });
	if (res) {
		if (getSelectLanguage()) {
			res.selectLanguage = getSelectLanguage();
		} else {
			res.selectLanguage = 'En';
		}
		res.languageList.forEach((item: LanguageObj) => {
			res.languageObjList[item.code] = { desc: item.desc, icon: item.icon };
		});
		return res;
	} else {
		return new NewLanguageInfo;
	}
};
// 游客登录接口调用
export const memberGuestLoginFun = async () => {
	const res = await memberGuestLoginApi({});
	if (res) {
		const { token, userId, uname } = res;
		setToken(token);
		setUserIdFun(userId);
		setUsername(uname);
		return res;
	} else {
		return { token: '' };
	}
};
// 会员登录接口调用
export const memberLoginAoFun = async (email: string, password: string) => {
	const res = await memberLoginApi({ email, password });
	if (res) {
		const { token, userId, uname, email } = res;
		setToken(token);
		setUserIdFun(userId);
		setUsername(uname);
		setAccountFun(email);
		return res;
	} else {
		return { token: '' };
	}
};
// 退出登录接口调用
export const memberLogoutLoFun = async () => {
	const res = await memberLogoutApi({});
	return res;
};
// 注册接口调用
export const memberRegisterLoFun = async (params: RegisterForm) => {
	const res = await memberRegisterApi(params);
	return res;
};
// 联系我们
export const contactUsSavaLoFun = async (params: ContactUsLo) => {
	const res = await contactUsSavaApi(params);
	return res;
};
